__turbopack_context__.v({
  "infoIcon": "PdpPriceContainerView-module-scss-module__jEkrnq__infoIcon",
  "memberGroupLabel": "PdpPriceContainerView-module-scss-module__jEkrnq__memberGroupLabel",
  "priceRow": "PdpPriceContainerView-module-scss-module__jEkrnq__priceRow",
});
